// export default EmailVerificationModal;

import { useState, useEffect } from "react";


// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

import { verifyCustomerOtp, verifyTokenApi, resendOtp } from "layouts/authentication/_request";
import { getAuthLocal } from "core/AuthHelper";
import EmailVerification from "layouts/authentication/components/EmailVerification";
import { useAuth } from "context";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import { getCampaignDetails } from "layouts/dashboard/_request";
import { updateCustomerInfoForCampaign } from "layouts/authentication/_request";
import PropTypes from "prop-types";
import config from "config/config";

const EmailVerificationModal = ({ refresh, setRefresh, forgotPassword }) => {
  const configData = config[process.env.REACT_APP_ENV?.toUpperCase() || "LOCAL"];
  const { showSnackbarWithMessage, saveAuthData, auth, logout } = useAuth();
  const [isSendingOTP, setIsSendingOTP] = useState(false);
  const [campaignCode, setCampaignCode] = useState(null);
  const [campaignExist, setcampaignExist] = useState(null);
  const [isVerified, setIsVerified] = useState(false);
  const [isCampaignAvailable, setIsCampaignAvailable] = useState(false);
  const [campaign, setCampaign] = useState("");
  const [restaurantName, setRestauranttName] = useState("");
  const [emails, setEmails] = useState([
    {
      email: "",
      isOTPVisible: true,
      otpNumber: "",
      emailError: "",
      optError: "",
      disabled: false,
      isVerified: false,
    },
  ]);

  useEffect(() => {
    if (forgotPassword) {
      setEmails([
        {
          email: "",
          isOTPVisible: true,
          otpNumber: "",
          emailError: "",
          optError: "",
          disabled: false,
          isVerified: false,
        },
      ]);
    }
  }, [forgotPassword]);

  const verifyTokenFunc = async () => {
    try {
      const auth = await getAuthLocal();
      const {
        data: { success, data },
      } = await verifyTokenApi({ accessToken: auth.accessToken });
      if (success) {
        const updatedEmails = [...emails];
        updatedEmails[0].email = data.verifiedData.email;
        updatedEmails[0].disabled = true;
        updatedEmails[0].isVerified = data.verifiedData.verifiedAt ? true : false;
        setEmails(updatedEmails);
      }
    } catch (e) {
      console.log(e.message);
    }
  };

  useEffect(() => {
    if (auth) {
      verifyTokenFunc();
    }
  }, [refresh, auth]);

  const handleFieldChange = (event, index) => {
    const { name, value } = event.target;
    const updatedEmails = [...emails];
    updatedEmails[index][name] = value;
    setEmails(updatedEmails);
  };

  const handleVerify = async (index) => {
    try {
      const {
        data: { success, message, data },
      } = await verifyCustomerOtp({ code: +emails[index].otpNumber });
      if (success) {
        saveAuthData(data.tokens);
        setRefresh(false);
        showSnackbarWithMessage({
          type: "success",
          message,
        });
        const url = `${configData.CUSTOMER_LINKS.SIGN_IN}?landing_page_tokens=${encodeURIComponent(JSON.stringify(data.tokens))}`;
        if (url) {
          window.location.href = url;
        }
        logout();
      } else {
        showSnackbarWithMessage({
          type: "error",
          message,
        });
      }
    } catch (e) {
      console.log(e.message);
      showSnackbarWithMessage({
        type: "error",
        message: e.message,
      });
    }
  };
  const handleReSendOTP = async (index) => {
    try {
      setIsSendingOTP(true);
      const {
        data: { success, message, data },
      } = await resendOtp(
        forgotPassword ? true : false,
        encodeURIComponent(emails[index]?.email?.trim())
      );
      if (success) {
        const updatedEmails = [...emails];
        updatedEmails[index].isOTPVisible = true;
        setEmails(updatedEmails);
        showSnackbarWithMessage({
          type: "success",
          message,
        });
        setIsSendingOTP(false);
      } else {
        showSnackbarWithMessage({
          type: "error",
          message,
        });
        setIsSendingOTP(false);
      }
    } catch (e) {
      console.log(e.message);
      showSnackbarWithMessage({
        type: "error",
        message: e.message,
      });
      setIsSendingOTP(false);
    }
  };
  const createInfoData = async () => {
    try {
      const {
        data: { success, message },
      } = await updateCustomerInfoForCampaign(campaignCode);
      if (success) {
        setcampaignExist(campaignCode);
        setIsVerified(true);
        showSnackbarWithMessage({
          type: "success",
          message,
        });
      } else {
        showSnackbarWithMessage({
          type: "error",
          message,
        });
      }
    } catch (e) {
      showSnackbarWithMessage({
        type: "error",
        message: e.message,
      });
    }
  };
  const campaignData = async () => {
    try {
      const {
        data: { success, data },
      } = await getCampaignDetails();
      if (success && data?.enrollments?.length) {
        const primary = data.enrollments[0];
        setIsCampaignAvailable(primary.isCampaign);
        setCampaign(primary.campaign);
        setRestauranttName(primary.restaurantName);
      }
    } catch (e) {
      console.log(e);
    }
  };
  useEffect(() => {
    if (auth) campaignData();
  }, [isVerified]);

  const closeEmailVerifyModal = () => {
    setEmails([
      {
        email: "",
        isOTPVisible: true,
        otpNumber: "",
        emailError: "",
        optError: "",
        disabled: false,
        isVerified: false,
      },
    ]);
  };

  const handleVerifyForgotPassword = async (index) => {
    try {
      const {
        data: { success, message, data },
      } = await verifyCustomerOtp({
        code: +emails[index].otpNumber,
        forgotPassword: true,
        userEmail: emails[index].email,
      });
      if (success) {
        showSnackbarWithMessage({
          type: "success",
          message,
        });
        const url = `${configData.CUSTOMER_LINKS.SIGN_IN}?landing_page_tokens=${encodeURIComponent(JSON.stringify(data.tokens))}`;
        if (url) {
          window.location.href = url;
        }
        logout();
        closeEmailVerifyModal();
      } else {
        showSnackbarWithMessage({
          type: "error",
          message,
        });
      }
    } catch (e) {
      console.log(e.message);
      showSnackbarWithMessage({
        type: "error",
        message: e.message,
      });
    }
  };

  return (
    <>
      <MDBox mb={2}>
        <MDTypography
          sx={{ color: "#101828", fontSize: "21px", textAlign: "center", fontWeight: 500 }}
        >
          {!forgotPassword ? "Email Verification" : "Forgot Password"}
        </MDTypography>
      </MDBox>

      <MDBox pt={3} pb={3} px={2}>
        <MDBox>
          {emails.map((emailData, index) => (
            <>
              <EmailVerification
                key={index}
                emailData={emailData}
                index={index}
                onFieldChange={handleFieldChange}
                onVerify={forgotPassword ? handleVerifyForgotPassword : handleVerify}
                onSendOTP={handleReSendOTP}
                isSendingOTP={isSendingOTP}
              />
            </>
          ))}
        </MDBox>
        {emails[0]?.isVerified && !forgotPassword && (
          <>
            <MDTypography variant="h6" fontWeight="regular" pb={1}>
              Do you have any promotion code?&nbsp;(optional)
            </MDTypography>
            <MDInput
              type="text"
              label={!campaignExist && "Campaign Code"}
              name="campaignCode"
              variant="outlined"
              disabled={campaignExist}
              value={campaignExist ? campaignExist : campaignCode}
              onChange={(e) => setCampaignCode(e.target.value)}
            />
            {campaignExist ? (
              <>
                <MDButton
                  variant="text"
                  color="success"
                  sx={{ cursor: "default", pointerEvents: "none" }}
                >
                  Applied
                </MDButton>
              </>
            ) : !campaignExist && campaignCode ? (
              <MDButton
                variant="text"
                color="info"
                onClick={() => {
                  createInfoData();
                  campaignData();
                }}
              >
                Verify
              </MDButton>
            ) : null}
          </>
        )}

        {isCampaignAvailable && campaignExist && (
          <MDBox
            variant="text"
            p={1}
            mt={3}
            sx={{
              backgroundColor: "#d4edda",
              display: "inline-flex",
              borderRadius: "4px",
            }}
            size="large"
          >
            {campaign?.type === "FIXED" ? (
              <MDTypography variant="button" fontWeight="normal" sx={{ cursor: "initial" }}>
                You are enrolled in
                <span style={{ fontWeight: "bold" }}>{` ${campaign?.name}`}</span> campaign of&nbsp;
                <span style={{ fontWeight: "bold" }}>{`${restaurantName}`}</span>
                &nbsp;restaurant. Enjoy additional reward of{" "}
                <span style={{ fontWeight: "bold" }}>{`${campaign?.fixedCashback} points`}</span> on
                your first order.
                {campaign.minimumOrderValueInCents !== "0" && (
                  <>
                    {" "}
                    Order minimum value must be greater than
                    <span
                      style={{ fontWeight: "bold" }}
                      dangerouslySetInnerHTML={{
                        __html: ` $${campaign.minimumOrderValueInCents / 100}`,
                      }}
                    />
                    .
                  </>
                )}
                {campaign.campaignExpiry && (
                  <>
                    {" "}
                    This offer will expire on
                    <span
                      style={{ fontWeight: "bold" }}
                      dangerouslySetInnerHTML={{
                        __html: ` ${new Date(campaign.campaignExpiry).toDateString()}`,
                      }}
                    />
                    .
                  </>
                )}
              </MDTypography>
            ) : (
              <MDTypography variant="button" fontWeight="normal" sx={{ cursor: "initial" }}>
                You are enrolled in
                <span style={{ fontWeight: "bold" }}>{` ${campaign?.name}`}</span> campaign of&nbsp;
                <span style={{ fontWeight: "bold" }}>{` ${restaurantName}`}</span>
                &nbsp;restaurant. Benefit from an additional cashback of{" "}
                <span style={{ fontWeight: "bold" }}>+{campaign.multiplierCashback}X</span> on top
                of your existing cashback incentive. Get bonus rewards points with every order
                {campaign.minimumOrderValueInCents === "0" && "."}
                {campaign.minimumOrderValueInCents !== "0" && (
                  <>
                    {", "}
                    with a minimum order value greater than
                    <span
                      style={{ fontWeight: "bold" }}
                      dangerouslySetInnerHTML={{
                        __html: ` $${campaign.minimumOrderValueInCents / 100}`,
                      }}
                    />
                  </>
                )}
                {campaign.campaignExpiry && (
                  <>
                    . This offer will expire on
                    <span
                      style={{ fontWeight: "bold" }}
                      dangerouslySetInnerHTML={{
                        __html: ` ${new Date(campaign.campaignExpiry).toDateString()}`,
                      }}
                    />
                    .
                  </>
                )}
              </MDTypography>
            )}
          </MDBox>
        )}

        {((!campaignCode && emails[0]?.isVerified) || campaignExist) && (
          <MDBox mt={4} mb={2} sx={{ display: "flex", justifyContent: "flex-end" }}>
            <MDButton
              variant={
                !campaignExist && !campaignCode && emails[0]?.isVerified ? "outlined" : "gradient"
              }
              color="success"
              onClick={() => {
                const url = `${configData.CUSTOMER_LINKS.SIGN_IN}?landing_page_tokens=${encodeURIComponent(JSON.stringify(auth))}`;
                if (url) {
                  window.location.href = url;
                }
                logout();
              }}
            >
              Continue
            </MDButton>
          </MDBox>
        )}
      </MDBox>
    </>
  );
};

EmailVerificationModal.propTypes = {
  refresh: PropTypes.bool,
  setRefresh: PropTypes.any,
  forgotPassword: PropTypes.bool,
};

export default EmailVerificationModal;
